<template>
	<div class='con'>
		<code-login ref="myCodeLogin" @update-page="updatePage"></code-login>
		<head-top head-title="我的物流" goBack="true"></head-top>
		<div class="bg_a top flex_b color_e font_size_c fw ">
			<!-- 课程、图书-->
			<div class="tab_item" :class="orderStatus==0?'active':''" @click="switchNav(0)">课程</div>
			<div class="tab_item" :class="orderStatus==1?'active':''" @click="switchNav(1)">图书</div>
		</div>

		<div class='main'>
			<div class="list">
				<!-- 课程 -->
				<div v-if="orderStatus==0">
					<div v-if="curriculumlogistics.length>0">
						<div v-for="(item, index) in curriculumlogistics" :key="index">
							<div class="booklogisticsList_item">
								<div class="booklogisticsList_item_top font_size_e flex_c">
									订单号：{{item.content.orderNumber}}
								</div>
								<div @click="toLogisticsDetail(item,orderStatus)" class="booklogistic_item">
									<div class="flex_c color_f font_size_a padding_bottom_a">
										<div class="flex_a">
											<div v-if="!item.content.dvyFlowId">暂无物流单号</div>
											<div v-else>{{item.content.dvyName}}：{{item.content.dvyFlowId}}</div>
											<img :src='resourceDomain+"static/icon/copy.png"' class="copyicon" v-if="item.content.dvyFlowId" @click.stop="copy_express_number(item.content.dvyFlowId)">
										</div>
									</div>
									<div class="flex_c">
										<div class="item_left">
											<img :src='resourceDomain + item.content.orderItems[0].pic' v-if='item.content.orderItems[0].pic'>
											<div class="totalnumber color_b font_size_d" v-if="item.content.orderItems.length>1">{{item.content.orderItems.length>99?'99+':item.content.orderItems.length}}件</div>
										</div>

										<div class="flex_b logistics_status_book">
											<div class="flex_c" style="width:100%">
												<div class="fw color_a font_size_c" v-if="item.content.orderStatus==2">
													待发货
												</div>
												<div class="fw color_a font_size_c" v-else-if="item.content.orderStatus==3">
													待收货
												</div>
												<div class="fw color_a font_size_c" v-else-if="item.content.orderStatus==5">
													已完成
												</div>
												<div class="fw color_a font_size_c" v-else-if="item.content.orderStatus==8">
													已退货
												</div>
												<div class="btn font_size_e color_g" @click.stop="confirm_receipt(item.content.orderNumber,index)" v-if="item.content.orderStatus==3">
													确认收货
												</div>
											</div>
											<div class="ellipsis_2 color_f font_size_a" style="width:100%">
												{{item.content.orderItems[0].name}}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="color_e font_size_c paddinga" style="text-align:center;" v-else>
						<img :src='resourceDomain+"static/icon/no_order.png"' class="noorderimg">
						暂无数据，逛逛别的分类吧~
					</div>
				</div>

				<!-- 图书 -->
				<div v-if="orderStatus==1">
					<div v-if="booklogisticsList.length>0">
						<div v-for="(item, index) in booklogisticsList" :key="index">
							<div class="booklogisticsList_item">
								<div class="booklogisticsList_item_top font_size_e flex_c">
									订单号：{{item.bookOrder.orderNumber}}
								</div>

								<div v-for="(t, idx) in item.dvyModelList" :key="idx" @click="toLogisticsDetail(t,orderStatus)" class="booklogistic_item">
									<div class="flex_c color_f font_size_a padding_bottom_a">
										<div class="flex_a">
											<div v-if="!t.deliveryDto">暂无物流单号</div>
											<div v-else>{{t.deliveryDto.companyName}}：{{t.dvyFlowId}}</div>
											<img :src='resourceDomain+"static/icon/copy.png"' class="copyicon" v-if="t.deliveryDto" @click.stop="copy_express_number(t.dvyFlowId)">
										</div>
									</div>
									<div class="flex_c">
										<div class="item_left">
											<img :src='resourceDomain + t.bookList[0].splitImg' v-if='t.bookList[0].splitImg'>
											<div class="totalnumber color_b font_size_d" v-if="t.dvyTotalNumber>1">{{t.dvyTotalNumber>99?'99+':t.dvyTotalNumber}}件</div>
										</div>

										<div class="flex_b logistics_status_book">
											<div class="flex_c" style="width:100%">
												<div class="fw color_a font_size_c" v-if="t.status==2">
													待发货
												</div>
												<div class="fw color_a font_size_c" v-else-if="t.status==3">
													待收货
												</div>
												<div class="fw color_a font_size_c" v-else-if="t.status==5">
													已完成
												</div>
												<div class="btn font_size_e color_g" @click.stop="confirmReceipt(t.id,index,idx)" v-if="t.status==3">
													确认收货
												</div>
											</div>
											<div class="ellipsis_2 color_f font_size_a" style="width:100%">
												{{t.bookList[0].title}}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="color_e font_size_c paddinga" style="text-align:center;" v-else>
						<img :src='resourceDomain+"static/icon/no_order.png"' class="noorderimg">
						暂无数据，逛逛别的分类吧~
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import api from '@/apis/api'
	import {
		mapGetters,
		mapActions
	} from 'vuex';
	export default {
		name: 'Logistics_list',
		components: {
			headTop: headTop
		},
		data() {
			return {
				resourceDomain: api.resourceDomain,
				curriculumlogistics: [], //课程物流
				booklogisticsList: [], //图书物流
				orderStatus: 0,
				id: undefined
			}
		},

		created() {
			this.updatePage()
		},

		methods: {
			...mapActions("userModule", ["SET_OPENID"]),
// 调用组件中的登录成功里的自定义的更新数据事件
			updatePage() {
				window.scrollTo(0, 0);
				if(this.orderStatus==0){
					// 课程
					this.getLogistics()
				}else if(this.orderStatus==1){
					// 图书
					this.getUserBookLogistics()
				}
			},

			//tab切换函数，课程和图书
			switchNav(v) {
				window.scrollTo(0, 0);
				this.orderStatus = v
				if(this.orderStatus==0){
					// 课程
					this.getLogistics()
				}else if(this.orderStatus==1){
					// 图书
					this.getUserBookLogistics()
				}
			},

			// 获取课程物流列表
			getLogistics() {
				api.get("/userCenter/tag", {
					tag: 4
				}).then((res) => {
					this.$toast.clear();
					console.log(res, "-----获取课程物流列表------");
					if (res.code == 20000) {
						this.curriculumlogistics = res.data.myLogistics.searchHits
					} else {
						this.$toast(res.message);
					}
				});
			},

			// 获取图书物流列表
			getUserBookLogistics() {
				api.get("/bookOrderDvy/getUserBookLogistics", {}).then((res) => {
					this.$toast.clear();
					console.log(res, "-----获取图书物流列表------");
					if (res.code == 20000) {
						this.booklogisticsList = res.data
					} else {
						this.$toast(res.message);
					}
				});
			},

			// 复制单号
			copy_express_number(orderNumber) {
				let text = orderNumber;
				let inputElement = document.createElement('input')
				inputElement.value = text;
				document.body.appendChild(inputElement);
				inputElement.select(); //选中文本
				document.execCommand("copy"); //执行浏览器复制命令
				inputElement.remove();
				this.$toast.success("复制成功")
			},

			// 图书确认收货
			confirmReceipt(bookOrderDvyId, index, idx) {
				this.$toast.loading({
					overlay: true,
					message: "",
					duration: 0,
				});

				api.post(`/bookOrderDvy/confirmReceipt/${bookOrderDvyId}`).then(res => {
					this.$toast.clear()
					if (res.code == 20000) {
						this.$set(this.booklogisticsList[index].dvyModelList[idx], 'status', 5);
					} else {
						this.$toast(res.message)
					}
				})
			},
			// 课程确认收货
			confirm_receipt(ordernumber, index) {
				this.$toast.loading({
					overlay: true,
					message: "",
					duration: 0,
				});

				api.post('/userCenter/confirmReceipt/' + ordernumber, {}).then(res => {
					this.$toast.clear()
					if (res.code == 20000) {
						this.$set(this.curriculumlogistics[index].content, 'orderStatus', 5);
					} else {
						this.$toast(res.message)
					}
				})

			},

			// 跳转物流详情
			toLogisticsDetail(item, orderStatus) {
				if (orderStatus == 0) {
					// 课程
					this.$router.push({
						path: "/logistics_detail",
						query: {
							orderNumber: item.content.orderNumber,
							orderStatus: orderStatus
						},
					});
				} else if (orderStatus == 1) {
					// 图书
					this.$router.push({
						path: "/logistics_detail",
						query: {
							bookOrderDvyId: item.id,
							orderStatus: orderStatus,
							bookOrderId: item.bookOrderId
						},
					});
				}
			},

		}
	}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>

	.logistics_status_book {
		width: 190px;
		flex-direction: column;
		height: 70px;
	}

	.noorderimg {
		width: 345px;
		height: 172.5px;
		margin: 15vh auto 25px;
		display:block;
	}

	.copyicon {
		width: 15px;
		height: 15px;
		margin-left: 5px;
	}

	.padding_bottom_a {
		padding-bottom: 8px;
	}

	.paddinga {
		padding: 15px 0;
	}

	.main {
		padding: 45px 0 15px;
	}

	.list {
		width: 345px;
		padding: 0 15px;
	}

	.number {
		position: absolute;
		left: 0;
		top: 0;
		background-color: #ee4346;
		border-radius: 5px;
		width: 40px;
		text-align: center;
		height: 20px;
		line-height: 20px;
		font-size: 11px;
	}

	.top {
		position: fixed;
		width: 100%;
		left: 0;
		right: 0;
		top: 48px;
		z-index: 999;
		height: 45px;
		line-height: 45px;
		letter-spacing: 1px;
	}

	.tab_item.active {
		color: #3b7bfd;
	}

	.tab_item.active::after {
		content: '';
		width: 25px;
		height: 3px;
		background-color: #3b7bfd;
		border-radius: 1.5px;
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translateX(-50%);
	}

	.tab_item {
		position: relative;
		height: 45px;
		line-height: 45px;
	}

	.btn {
		border-radius: 5px;
		border: 1px solid #ff6719;
		width: 75px;
		height: 24px;
		line-height: 24px;
		text-align: center;
	}

	.item_left {
		padding: 4px;
		border-radius: 5px;
		border: 1px solid #eee;
		position: relative;
	}

	.con {
		padding-top: 48px;
	}

	.item_left img {
		width: 110px;
		height: 55px;
		border-radius: 5px;
		display: block;
	}

	.totalnumber {
		background-color: #ff0000;
		position: absolute;
		left: 0;
		top: 0;
		padding: 0 5px;
		border-radius: 5px 0 5px 0;
	}

	.booklogisticsList_item {
		border: 1px solid #eee;
		border-radius: 5px;
		margin-bottom: 20px;
	}

	.booklogisticsList_item_top {
		background-color: #f4f5f6;
		padding: 8px 10px;
		height: 19px;
		line-height: 19px;
		border-radius: 5px 5px 0 0;
	}

	.booklogistic_item {
		padding: 15px 10px;
		border-bottom: 1px solid #eee;
	}

	.booklogistic_item:last-child {
		border-bottom: none !important;
	}
</style>
